import { Link } from 'react-router-dom';
import { Logo } from '@anamnia/ui';
import { PORTAL_URL } from '../lib/config.js';

export function SiteHeader() {
  return (
    <header className="border-b border-neutral-100 bg-neutral-0/90 backdrop-blur sticky top-0 z-10">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" aria-label="Inicio">
          <Logo />
        </Link>
        <nav className="flex items-center gap-3 md:gap-6 text-sm font-medium text-neutral-700">
          <a href="#producto" className="hidden md:inline hover:text-brand-700">
            Producto
          </a>
          <a href="#para-quien" className="hidden md:inline hover:text-brand-700">
            Para quién
          </a>
          <a
            href={`${PORTAL_URL}/login`}
            className="rounded-md border border-brand-600 px-3 py-1.5 text-brand-700 hover:bg-brand-50"
          >
            Iniciar sesión
          </a>
          <a
            href={`${PORTAL_URL}/signup`}
            className="hidden md:inline-block rounded-md bg-brand-600 px-3 py-1.5 text-neutral-0 hover:bg-brand-700"
          >
            Solicita acceso
          </a>
        </nav>
      </div>
    </header>
  );
}
